import { Languages } from "lucide-react";
import { LANGS, useLang } from "../lib/i18n";

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex flex-wrap items-center gap-1 rounded-full bg-white/10 border border-white/20 p-1 backdrop-blur ${className}`} role="group" aria-label="Language" data-testid="language-toggle">
      <Languages size={14} className="text-[#d6aa43] ml-2" />
      {LANGS.map(([code, label]) => (
        <button key={code} type="button" onClick={() => setLang(code)} aria-pressed={lang === code} data-testid={`lang-${code}`}
          className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-[0.1em] transition-colors ${lang === code ? "bg-[#d6aa43] text-[#0a0d12]" : "text-white/90 hover:text-white"}`}>
          {label}
        </button>
      ))}
    </div>
  );
};
